import React, { memo } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'
import EditableContainer from '@v4/components/common/EditableContainer'
import EditableHTML from '@v4/components/common/EditableHTML'
import ItemBorder from '@v4/components/common/ItemBorder'
import Check from '@v4/components/common/FAIcons/Regular/Check'
import PlayRegular from '@v4/components/common/FAIcons/Regular/Play'
import PlaySolid from '@v4/components/common/FAIcons/Solid/Play'
import { EDITOR_VARIANT } from '@v4/hooks/useEditor'
import { useItem } from './Item.hooks'

const Item = props => {
	const [
		{ classes, itemKey, imagePath, watched, group, active, text, textConfig, textEditable, textKey },
		{ handleTextClick, handleTextChange, handleClick },
	] = useItem(props)

	return (
		<ItemBorder itemKey={itemKey} group={group} outlineOffset={0}>
			<Box className={clsx(classes.root, active && classes.active, 'video9-item-root')} onClick={handleClick}>
				{active ? <PlaySolid className={classes.playIcon} /> : <PlayRegular className={classes.playIcon} />}
				<EditableContainer
					visible={!!text}
					fieldConfig={textConfig}
					onAdd={handleTextChange}
					editable={textEditable}
				>
					<EditableHTML
						className={clsx(classes.text, 'video9-text-item')}
						html={text}
						component="div"
						onClick={handleTextClick}
						editable={textEditable}
						onChange={handleTextChange}
						key={textKey}
						editorVariant={EDITOR_VARIANT.SIMPLE}
					/>
				</EditableContainer>
				<div className={classes.iconsContainer}>
					{active && <img src={imagePath} alt="equalizer" className={classes.equalizer} />}
					{!active && watched && <Check className={classes.checkIcon} />}
				</div>
			</Box>
		</ItemBorder>
	)
}

Item.propTypes = {
	group: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	itemKey: PropTypes.string.isRequired,
	active: PropTypes.bool,
	watched: PropTypes.bool,
	onVideoClick: PropTypes.func,
}

export default memo(Item)
